import * as React from "react";
import { toast } from "react-toastify";

export const dismiss = (id: any) =>
    toast.dismiss(id);

export const copyableError = (message: string[]) =>
    toast.error(
        <span>
            {message.map((m) => (
                <div key={m}>{m}</div>
            ))}
        </span>,
        {
            className: "toast-error toast-wide",
            autoClose: false,
            draggable: false,
            closeOnClick: false,
            style: { overflow: "auto", maxHeight: "70vh" }
        }
    );

export const copyableInfo = (message: string) =>
    toast.info(
        <span>
            {message}
        </span>,
        {
            className: "toast-info",
            progressClassName: "progress",
            autoClose: false,
            draggable: false,
            closeOnClick: false,
        }
    );

export const info = (message: string) =>
    toast.info(
        <span>
            {message}
        </span>,
        { className: "toast-info", progressClassName: "progress" }
    );

export const warning = (message: string) =>
    toast.warn(
        <span>
            {message}
        </span>,
        { className: "toast-warning" }
    );

export const error = (message: string) =>
    toast.error(
        <span>
            {message}
        </span>,
        { className: "toast-error" }
    );

export const success = (message: string) =>
    toast.success(
        <span>
            {message}
        </span>,
        { className: "toast-success" }
    );
